<template>
    <div v-if="pending" class="text-center" style="transition: none !important;">
        <b-spinner/>
    </div>

    <main v-else>
        <header class="justify-between align-items-stretch mb-3">
            <b-breadcrumb class="flex-grow-1 mb-0">
                <b-breadcrumb-item :to="{ name: 'staff_members.index' }">
                    {{ $t('Staff members') }}
                </b-breadcrumb-item>

                <b-breadcrumb-item active>
                    {{ staffMemberId ? staffMember.originalData.name : $t('Create') }}
                </b-breadcrumb-item>
            </b-breadcrumb>

            <b-dropdown
                v-if="staffMemberId"
                :id="'staff_member_actions_dropdown_' + staffMember.id"
                :title="$t('Actions')"
                class="ml-3"
                right
                no-caret
            >
                <template slot="button-content">
                    <fa icon="ellipsis-v" fixed-width/>
                </template>

                <b-dropdown-item variant="danger" @click="handleDelete">
                    <fa icon="trash" fixed-width/>
                    {{ $t('Delete') }}
                </b-dropdown-item>
            </b-dropdown>
        </header>

        <b-card class="mb-3" no-body tag="section">
            <b-form
                @submit.prevent="save"
                @keydown="staffMember.onKeydown($event)"
            >
                <b-card-body>
                    <b-form-group
                        :label="$t('Name')"
                        label-for="name"
                        :state="staffMember.errors.has('name') ? false : null"
                        :invalid-feedback="staffMember.errors.get('name')"
                    >
                        <b-form-input
                            id="name"
                            v-model="staffMember.name"
                            autofocus
                            name="name"
                            :state="staffMember.errors.has('name') ? false : null"
                        />
                    </b-form-group>

                    <b-form-group
                        :label="$t('Role')"
                        label-for="role"
                        :state="staffMember.errors.has('role') ? false : null"
                        :invalid-feedback="staffMember.errors.get('role')"
                    >
                        <b-form-select
                            id="role"
                            v-model="staffMember.role"
                            name="role"
                            :options="roles"
                            :state="staffMember.errors.has('role') ? false : null"
                        />
                    </b-form-group>

                    <b-alert variant="success" dismissible fade :show="staffMember.successful ? 2 : 0">
                        {{ $t('Saved') }}
                    </b-alert>
                </b-card-body>

                <b-card-footer>
                    <b-button
                        v-if="!staffMemberId || staffMember"
                        :disabled="staffMember.busy"
                        type="submit"
                        variant="primary"
                    >
                        {{ staffMemberId ? $t('Save') : $t('Create') }}
                        <b-spinner v-show="staffMember.busy" small/>
                    </b-button>
                </b-card-footer>
            </b-form>
        </b-card>
    </main>
</template>

<script>
    import Form from 'vform';
    import {STAFF_MEMBER_ROLES, USER_ROLES} from '@/constants';

    export default {
        name: 'StaffMember',
        props: {
            staffMemberId: {
                type: [Number, String],
                default: null,
            },
        },
        data() {
            return {
                pending: false,
                staffMember: new Form({
                    name: null,
                    role: STAFF_MEMBER_ROLES.STAFF_MEMBER,
                }),
                STAFF_MEMBER_ROLES
            };
        },
        computed: {
            roles() {
                return Object.values(STAFF_MEMBER_ROLES).map(role => {
                    return {
                        value: role,
                        text: this.$t(role),
                    }
                })

            }
        },
        async beforeRouteEnter(to, from, next) {
            await next(vm => vm.fetchData(to.params.staffMemberId));
        },
        async beforeRouteUpdate(to, from, next) {
            if (to.params.staffMemberId) {
                this.fetchData(to.params.staffMemberId);
            } else {
                this.staffMember = new Form();
            }
            next();
        },
        methods: {
            async fetchData(staffMemberId) {
                if (!staffMemberId) {
                    return this.setData({});
                }

                if (this.pending) {
                    return;
                }

                this.pending = true;

                let {data} = await this.axios.get(`/api/staff_members/${staffMemberId}`);
                this.setData(data);

                this.pending = false;
            },

            save() {
                let method = this.staffMemberId ? 'put' : 'post';
                let url = this.staffMemberId ? `/api/staff_members/${this.staffMemberId}` : `/api/staff_members`;

                this.staffMember.submit(method, url).then(response => {
                    if (response.status === 201) {
                        this.$root.$emit('created::staff_member', response.data);
                        this.$router.push({
                            name: 'staff_members.show',
                            params: {
                                staffMemberId: response.data.id,
                            },
                        })
                    } else {
                        this.$root.$emit('updated::staff_member', this.staffMember.data());
                    }
                });
            },

            async handleDelete() {

                if (!confirm(this.$t('Are you sure'))) {
                    return;
                }

                await this.axios.delete(`/api/staff_members/${this.staffMemberId}`);

                this.$root.$emit('deleted::staff_member', this.staffMemberId);

                this.$router.push({
                    name: 'staff_members.create',
                });
            },

            setData(data) {
                this.staffMember = new Form(data);
            },
        },
    };
</script>
